import { ViewContextActions } from '../actions/viewContextActions';
import { ViewContextAction, ViewState } from '../../../types';
import { ViewStateEnum } from '../viewStateEnum';

function viewContextReducer(
  state: ViewState,
  action: ViewContextAction,
): ViewState {
  switch (action.type) {
    case ViewContextActions.ShowMainTransactionDataFormView: {
      return { ...state, state: ViewStateEnum.FILL_MAIN_TRANSACTION_DATA };
    }

    case ViewContextActions.MakeRequest: {
      return { ...state, state: ViewStateEnum.MAKE_REQUEST };
    }

    case ViewContextActions.ShowResult: {
      return { ...state, state: ViewStateEnum.SHOW_RESULT };
    }

    case ViewContextActions.ShowError: {
      return { ...state, state: ViewStateEnum.SHOW_ERROR, data: action.data };
    }

    case ViewContextActions.ShowSpinner: {
      return { ...state, state: ViewStateEnum.SHOW_SPINNER };
    }

    default: {
      throw new Error(`Unhandled action type: ${JSON.stringify(action)}`);
    }
  }
}

export { viewContextReducer };
